import { Component, OnInit } from '@angular/core';
import { lang_help } from 'app/idiomas/i18n/ayuda/ayuda.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { fuseAnimations } from '@fuse/animations';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import * as colabInter from 'app/main/pagina/encuestador-n35/colaboradores35/colaboradores35.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-videos-administrador',
  templateUrl: './videos-administrador.component.html',
  styleUrls: ['./videos-administrador.component.scss'],
  animations : fuseAnimations
})
export class VideosAdministradorComponent implements OnInit {
  productoCertificar: backInter.prodNorma35;
  password:boolean = false;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
  ) {
    lang_help.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.obtieneCertificarActual();
  }

  obtieneCertificarActual(){
    console.log("Obtener actual");
     this.wizardService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
       let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
       var BreakException = {};
       try {
         prodsCertificar.forEach( (producto) => {
           if(producto.completoNorma35 === 1){
             this.productoCertificar = producto;
             console.log(this.productoCertificar);
             throw BreakException;
           }
           });
       } catch (e) {
           if (e !== BreakException) throw e;
       };

     }, error  => {
       console.log("error al recuperar certificar vigente");
     });
   }

   private onPassword(event){
    let Pass:any;
    Pass=event.target.value.trim();
    console.log("Password "+Pass);
    //this.productoCertificar.claveVideo;
    if(Pass == this.productoCertificar.claveVideo){
      this.password=true;

      Swal.fire({
        icon: 'success',
        title: 'Contraseña correcta', // advice 5
        confirmButtonColor: '#e40601'
      });

    }else{
      Swal.fire({
        icon: 'error',
        title: 'Contraseña no valida', // advice 5
        confirmButtonColor: '#e40601'
      });
    }
  }
  videos1 = [
    {
      titulo  : "Video de Introducción 1",
      descripcion  : "Es una descripción 1",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 1_15 NORMA 035.mp4',
    },{
      titulo  : "Video de Introducción 2",
      descripcion  : "Es una descripción 2",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 2_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué son los factores de riesgo psicosocial?",
      descripcion  : "Es una descripción 3",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 3_15 NORMA 035.mp4',
    }
  ]

  videos2 = [
    {
      titulo  : "¿Qué es un entorno organizacional favorable? ",
      descripcion  : "Es una descripción 1",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 4_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué debo considerar al realizar mi política?",
      descripcion  : "Es una descripción 2",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 5_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué son las medidas de prevención de riesgo psicosocial?",
      descripcion  : "Es una descripción 3",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 6_15 NORMA 035.mp4',
    }
  ]

  videos3 = [

    {
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto al liderazgo y las relaciones en el trabajo?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 7_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto a las cargas de trabajo?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 8_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto al control de trabajo?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 9_15 NORMA 035.mp4',
    },

  ]

  videos4 = [

    {
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto al apoyo social?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 10_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto  a el equilibrio en la relación trabajo-familia?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/Video 11_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto  a el reconocimiento en el trabajo?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/Video 12_15 NORMA 035.mp4',
    },

  ]
  videos5 = [

    {
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto  la violencia en el trabajo o laboral?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/Video 13_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto a la información y comunicación que se proporciona a los trabajadores ?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 14_15 NORMA 035.mp4',
    },{
      titulo  : "¿Qué deben considerar las acciones y programas  con respecto a la capacitación y adiestramiento que se proporciona a los trabajadores?",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/norma-035_Administrador/VIDEO 15_15 NORMA 035.mp4',
    },

  ]


  videosTips1 = [

    {
      titulo  : "Over view",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/1. Over view LISTO .mp4',
    },{
      titulo  : "Tipos de usuarios",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/2. Tipos de usuario LISTO .mp4',
    },{
      titulo  : "Carga de logo",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/3. Carga de logo.mp4',
    },

  ]
  videosTips2 = [
    {
      titulo  : "Requerimientos técnicos",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/4 Requerimientos tecnicos.mp4',
    },{
      titulo  : "Llenado de plantilla",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/5. Llenado de plantilla.mp4',
    },{
      titulo  : "Carga de plantilla",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/6. Carga de plantilla.mp4',
    },
  ]
  videosTips3 = [
    {
      titulo  : "Programar encuesta",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/7. Programar encuesta LISTO.mp4',
    },{
      titulo  : "Pruebas del cuestionario",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/8. Pruebas del cuestionario.mp4',
    },{
      titulo  : "Lanzamiento y conteos",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/9. Lanzamiento y conteos.mp4',
    },
  ]



}
